<template>
  <div class="SERiskComponent">
    <p><b>{{ lang.infotext_1 }}:</b> {{data["MPN"]}}<br> <b>{{ lang.infotext_2 }}:</b> {{ data["Manufacturer"] }}</p>
    <div>
        <b-tabs content-class="mt-3">
        <b-tab title="Risks" active>
            <b-card-group deck>
                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" :border-variant="statusOverall" header="Overall" class="text-center" :header-bg-variant="statusOverall">
                    <b-card-text><p class="cardBorder">{{ data["Risk.Overall"] }}</p></b-card-text>
                </b-card>

                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" header="Lifecycle" :border-variant="statusLifecycle" class="text-center"  :header-bg-variant="statusLifecycle" >
                    <b-card-text><p class="cardBorder">{{ data["Risk.Lifecycle"] }}</p></b-card-text>
                </b-card>

                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" :border-variant="statusInventory" header="Inventory" class="text-center" :header-bg-variant="statusInventory">
                    <b-card-text><p class="cardBorder">{{ data["Risk.Inventory"] }}</p></b-card-text>
                </b-card>
                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" header="Last Update Date " class="text-center">
                    <b-card-text><p class="cardBorder">{{ data["Risk.LastUpdateDate "] }}</p></b-card-text>
                </b-card>
            </b-card-group>
            <b-card-group deck>
                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" header="Lifecycle Stage" class="text-center">
                    <b-card-text><p class="cardBorder">{{ data["Risk.LifecycleStage"] }}</p></b-card-text>
                </b-card>

                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" header="MultiSourcing" class="text-center" :border-variant="statusMultiSourcing" :header-bg-variant="statusMultiSourcing">
                    <b-card-text><p class="cardBorder">{{ data["Risk.MultiSourcing"] }}</p></b-card-text>
                </b-card>

                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" header="Number Of Distributors" class="text-center" :border-variant="statusNumberOfDistributors" :header-bg-variant="statusNumberOfDistributors">
                    <b-card-text><p class="cardBorder">{{ data["Risk.NumberOfDistributors"] }}</p></b-card-text>
                </b-card>
                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" header="Number Of Other Sources" class="text-center">
                    <b-card-text><p class="cardBorder">{{ data["Risk.NumberOfOtherSources"] }}</p></b-card-text>
                </b-card>
            </b-card-group>
            <b-card-group deck>
                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" header="Predicted Obsolescence Year " class="text-center">
                    <b-card-text><p class="cardBorder">{{ data["Risk.PredictedObsolescenceYear"] }}</p></b-card-text>
                </b-card>

                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" :border-variant="statusRohsRisk" header="Rohs Risk" class="text-center"  :header-bg-variant="statusRohsRisk">
                    <b-card-text><p class="cardBorder">{{ data["Risk.RohsRisk"] }}</p></b-card-text>
                </b-card>

                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" header="SE Grade" class="text-center">
                    <b-card-text><p class="cardBorder">{{ data["Risk.SEGrade"] }}</p></b-card-text>
                </b-card>
                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" header="Years EOL" class="text-center" :border-variant="statusYearsEOL" :header-bg-variant="statusYearsEOL">
                    <b-card-text><p class="cardBorder">{{ data["Risk.YearsEOL"] }}</p></b-card-text>
                </b-card>
        
                
            
            </b-card-group>
        </b-tab>
        <b-tab title="Lifecycle" >
            <b-card-group deck>
                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" :border-variant="statusLifecycle" header="Lifecycle" class="text-center" :header-bg-variant="statusLifecycle">
                    <b-card-text><p class="cardBorder">{{ data["Lifecycle"] }}</p></b-card-text>
                </b-card>

                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" header="Estimated EOL Date"  class="text-center">
                    <b-card-text><p class="cardBorder">{{ data["Lifecycle.EstimatedEOLDate"] }}</p></b-card-text>
                </b-card>

                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" :border-variant="white" header="Estimated Years To EOL" class="text-center" :header-bg-variant="transparent">
                    <b-card-text><p class="cardBorder">{{ data["Lifecycle.EstimatedYearsToEOL"] }}</p></b-card-text>
                </b-card>
                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" header="LTB Date" class="text-center">
                    <b-card-text><p class="cardBorder">{{ data["Lifecycle.LTBDate"] }}</p></b-card-text>
                </b-card>
            </b-card-group>

            <b-card-group deck>
                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" :border-variant="white" header="Maximum Estimated Years To EOL" class="text-center" :header-bg-variant="transparent">
                    <b-card-text><p class="cardBorder">{{ data["Lifecycle.MaximumEstimatedYearsToEOL"] }}</p></b-card-text>
                </b-card>

                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" header="Minimum Estimated Years To EOL"  class="text-center">
                    <b-card-text><p class="cardBorder">{{ data["Lifecycle.MinimumEstimatedYearsToEOL"] }}</p></b-card-text>
                </b-card>

                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" :border-variant="white" header="PartStatus" class="text-center" :header-bg-variant="transparent">
                    <b-card-text><p class="cardBorder">{{ data["Lifecycle.PartStatus"] }}</p></b-card-text>
                </b-card>
                <b-card :bg-variant="cardColorsBg" :text-variant="cardColorsText" header="Risk Grade" class="text-center">
                    <b-card-text><p class="cardBorder">{{ data["Lifecycle.RiskGrade"] }}</p></b-card-text>
                </b-card>
            </b-card-group>

            

        </b-tab>
        	
    
    
      </b-tabs>
        
    </div>

    
 </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

export default {
  name: 'SERiskComponent',
  props:{
    lang: Object,
    data: Object
  },
  components: {


  },
  data () {
      return {
        transparent: "transparent",
        white: "white"

      }
  },
    computed: {
    
    variant() {
        if (this.$store.getters.s_skinVariant == "dark") {
            return "light";
        } else {
            return "dark";
        }

      },
    colors() {
        if (this.$store.getters.s_skinVariant == "dark") {
            return ['tabs-bg-dark', 'tabs-text-light']
        } else {
            return ['tabs-bg-light', 'tabs-text-dark']
        }

    },
    textColors() {
        if (this.$store.getters.s_skinVariant == "dark") {
            return ['tabs-bg-dark', 'tabs-text-light']
        } else {
            return ['tabs-bg-light', 'tabs-text-dark']
        }

    },
    cardColorsBg() {
        if (this.$store.getters.s_skinVariant == "dark") {
            return "dark";
        } else {
            return "secondary";
        }

    },
    cardColorsText() {
        if (this.$store.getters.s_skinVariant == "dark") {
            return "white";
        } else {
            return "dark"
        }

    },
      statusOverall() {
        
        let index = this.data["Risk.Overall"].indexOf("%");
        if (index > -1) {
            let temp = this.data["Risk.Overall"].split("%");
            
            if (temp[0] < 25) {
                return "success";
            } else if (temp[0] > 50) {
                return "danger";
            } else if (!(temp[0] < 25) && !(temp[0] > 50)) {
                return "warning";

            }
        }
        return "warning"
    },
      statusInventory() {
        if(this.data["Risk.Inventory"] == "Low"){
            return "success"
        }
        if (this.data["Risk.Inventory"] == "Medium") {
            return "warning"
        }
        if (this.data["Risk.Inventory"] == "High") {
            return "danger"
        }
        return "";
      },
      statusLifecycle() {
        if (this.data["Risk.Lifecycle"] == "Low") {
            return "success"
        }
        if (this.data["Risk.Lifecycle"] == "Medium") {
            return "warning"
        }
        if (this.data["Risk.Lifecycle"] == "High") {
            return "danger"
        }
        return "";
      },
      statusMultiSourcing() {
        if (this.data["Risk.MultiSourcing"] == "Low") {
                return "success"
            }
            if (this.data["Risk.MultiSourcing"] == "Medium") {
                return "warning"
            }
            if (this.data["Risk.MultiSourcing"] == "High") {
                return "danger"
            }
            return "";
      },
      statusNumberOfDistributors() {
        if (this.data["Risk.NumberOfDistributors"] < 2) {
                return "danger";
            } else if (this.data["Risk.NumberOfDistributors"] > 5) {
                return "success";
            } else if (!(this.data["Risk.NumberOfDistributors"] <= 5) && !(this.data["Risk.NumberOfDistributors"] >= 2)) {
                return "warning";

            }
        
        return ""
      },
      statusYearsEOL() {
        if (this.data["Risk.YearsEOL"] < 5) {
                return "danger";
            } else if (this.data["Risk.YearsEOL"] == 10) {
                return "success";
            } else if (!(this.data["Risk.YearsEOL"] <= 10) && !(this.data["Risk.YearsEOL"] >= 5)) {
                return "warning";

            }

            return ""
      },
      statusRohsRisk() {
        if (this.data["Risk.RohsRisk"] == "Low") {
            return "success"
        }
        if (this.data["Risk.RohsRisk"] == "Medium") {
            return "warning"
        }
        if (this.data["Risk.RohsRisk"] == "High") {
            return "danger"
        }
        return "white";
      },
      statusLifecycle() {
        if (this.data["Lifecycle"] == "Active") {
            return "success"
        }
        
        
        return "danger";
      }
  },
  created () {


  },
  watch: {
    value: function (newVal, oldVal) {


    }
  },
  updated() {



  },
  mounted: function () {

  },

  methods: {
    


  }
}
</script>


<style scoped>
    .card{
        border: solid 1px;
        margin: 8px;
    }
    .cardBorder{
        font-size: 18px;
    }

</style>


// WEBPACK FOOTER //
// src/components/shared/SERiskComponent.vue